import styled from 'styled-components';

export const Container = styled.div`
  padding: 16px;
  max-width: 1400px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
`;
